import { render } from "./questionInfos.vue?vue&type=template&id=6a0e8d6c&scoped=true"
import script from "./questionInfos.vue?vue&type=script&lang=js"
export * from "./questionInfos.vue?vue&type=script&lang=js"

import "./questionInfos.vue?vue&type=style&index=0&id=6a0e8d6c&lang=less&scoped=true"
import "./questionInfos.vue?vue&type=style&index=1&id=6a0e8d6c&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0e8d6c"]])

export default __exports__